import React, { useState, useContext } from 'react';
import './LandingPagePopUp.css';
import ROUTES from '../../services/Constants/GlobalRoutes.jsx';
import { useNavigate } from 'react-router-dom';
import PopUpImage from '../../assets/PopUpImage.png';
import DualButtons from '../../components/DualButtons/DualButtons.jsx';
import PropTypes from 'prop-types';
import PropTypeShapes from '../../services/Constants/PropTypeShapes.jsx';
import { UserDetailsContext } from '../../services/context/UserDetailsContext.js';
import { formatCurrency } from '../../services/Constants/config.js';
/**
 *
 * @param {object} props - the props of the component
 * @param {PropTypes.func} props.onShowPopupChange - function to show the popup
 *  @param {props.subscriptionDetails} props.subscriptionDetails - subscription details of the user
 * @returns {JSX.Element} AdvanceInfo Component
 */
export default function LandingPagePopUp({ onShowPopupChange, subscriptionDetails }) {
  const [showPopup, setShowPopup] = useState(true);
  const navigateTo = useNavigate();
  const userDetails = useContext(UserDetailsContext);
  const subscriptionFee = formatCurrency(subscriptionDetails?.subscriptionFee);

  const handleClose = () => {
    setShowPopup(false);
    onShowPopupChange(false);
  };

  if (!showPopup) return null;

  if (userDetails.vsp === true) {
    return (
      <div className='popup-container'>
        <div className='popup-content'>
          <img
            src={ PopUpImage }
            alt='Discount Banner'
            className='popup-image'
          />
          <div className='header-text'>
            UP TO 50% EXTRA VALUE
          </div>
          <div className='description'>
            <div className='popup-description'>
              Exclusive deals & vouchers from top brands!
            </div>
            <div className='sub-description'>Unlock more value, every time you shop</div>
          </div>
          <div className='popup-button-block'>
            <DualButtons
              primaryOnClick={ () => navigateTo(ROUTES.VODAPAY_CLUB) }
              secondaryOnClick={ handleClose }
              primaryText={ `Join for only R${subscriptionFee} per month` }
              secondaryText={ 'Close' }
            />
          </div>
        </div>
      </div>
    );
  }

  return null;
}

LandingPagePopUp.propTypes = {
  onShowPopupChange: PropTypes.func,
  subscriptionDetails: PropTypeShapes.subscriptionDetails,
};
